const React = require('react');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: Button } = require('@mui/material/Button');

module.exports = function InappropriateLanguageDialog({ open, words = [], onClose }) {

    return <Dialog open={open} onClose={onClose} aria-labelledby='alert-Inappropriate-Message-title' aria-describedby='alert-Inappropriate-Message-description'>
        <DialogTitle id='alert-Inappropriate-Message-title'>Warning</DialogTitle>
        <DialogContent><DialogContentText id='alert-Inappropriate-Message-description'>
            Sorry, we detected inappropriate language in your message which violates community standards.
            {words.length > 0 && <><br /><br />The following word(s) are not allowed: <strong>{words.join(', ')}</strong></>}
            <br /><br />Please edit your message.
        </DialogContentText></DialogContent>
        <DialogActions><Button onClick={onClose} color='primary' autoFocus>OK</Button></DialogActions>
    </Dialog>;
};
